import React, { Component, useState } from "react";
import { activateUser, useAuthState, useAuthDispatch } from '../../Context';

function Activate(props){
    const [email, setEmail] = useState('');
    const [code, setCode] = useState('');

    const dispatch = useAuthDispatch();
    const { loading, errorMessage } = useAuthState();

    const actiUser = async (e) =>{
        e.preventDefault();
        try {
            let response = await activateUser(dispatch, {"email": email,"code": code})
            console.log(response)
            if (response.status === 200){
                props.history.push('/');
            };
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="submit-form">
                <div>
                    <div className="form-group">
                        <label htmlFor="title">Email</label>
                        <input
                            type="text"
                            className="form-control"
                            id="regEmail"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            name="regEmail"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="title">Code</label>
                        <input
                            type="text"
                            className="form-control"
                            id="code"
                            required
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            name="code"
                        />
                    </div>
                    <button onClick={actiUser} className="btn btn-success">
                        Activate
                    </button>
                </div>
        </div>
    )
}

export default Activate
